import { HelpIcon } from 'components/shared/Icons'
import Instructions from '../instructions/Instructions'
import { useState } from 'react'

export function HelpButton() {
    const [show, setShow] = useState(false)

    return (
        <>
            <button className='btn-help' onClick={() => setShow(true)}>
                <HelpIcon />
            </button>
            <Instructions show={show} onHide={() => setShow(false)} />
        </>
    )
}
